import { lazy } from 'react'

/** PillNav (GSAP, ~30 kB) se descarga al montarla: quien la use debe envolverla en <Suspense>. */
export const PillNav = lazy(() => import('./PillNav/PillNav'))
